import { Text, Button, Stack, Link, VStack } from '@chakra-ui/react'

export const LoginGovBr = () => {
  return (
    <Stack w="full" spacing={6}>
      <Text 
        bgGradient="linear(to-r, esmeralda.100, marinho.100)" 
        bgClip='text'
        fontSize="4xl"
        fontWeight="semibold"
      >
        Acesso gov.br
      </Text>
      <Stack px={6} py={8} spacing={6} border="2px" borderColor="gray.80" >
        <Text>
          O GovBR é um serviço online de identificação e autenticação digital do
          cidadão em único meio, para acesso aos diversos serviços públicos
          digitais.
        </Text>
        <VStack spacing={6} alignItems="center">
          <Button variant="default" px={6}>
            Entrar com conta gov.br
          </Button>
          <Text as={Link} href='https://www.gov.br/pt-br' isExternal>
            Saiba mais sobre o GOV.BR
          </Text>
        </VStack>
      </Stack>
    </Stack>
  );
};